import { HMREnum } from 'Common/Constants/Enumeration/HMREnum';

export const getHouseholdExceptionString = (
  householdException,
  caseTypeLookup
) => {
  if (!householdException) {
    return null;
  }
  let output = [];
  if (
    householdException.CaseNumber &&
    householdException.CaseNumber.trim().length > 0
  ) {
    output.push('Case # ' + householdException.CaseNumber);
  }

  if (
    householdException.HMRCategory &&
    householdException.HMRCategory !== HMREnum.NotApplicable
  ) {
    output.push(Object.keys(HMREnum)[householdException.HMRCategory]);
  }

  if (householdException.IsDirectCertified === true) {
    output.push('DC');
  }

  if (householdException.IsEmancipatedMinor === true) {
    output.push('Emancipated');
  }

  if (householdException.IsExtendedBenefits === true) {
    output.push('Extended Benefits');
  }

  if (householdException.IsFoster === true) {
    output.push('Foster');
  }

  if (householdException.IsHeadStart === true) {
    output.push('HeadStart');
  }

  if (householdException.IsKinGap === true) {
    output.push('KinGAP');
  }

  if (
    caseTypeLookup &&
    householdException.CaseTypeId &&
    householdException.CaseTypeId !== 0
  ) {
    const foundCaseType = caseTypeLookup.find(
      x => x.Id === householdException.CaseTypeId
    );
    if (foundCaseType) {
      output.push(foundCaseType.Description);
    }
  }
  return output.join(', ');
};

const hasIncome = member => {
  if (
    member &&
    member.Income &&
    (member.Income.Income1 > 0 ||
      member.Income.Income2 > 0 ||
      member.Income.Income3 > 0 ||
      member.Income.Income4 > 0)
  ) {
    return true;
  }
  return false;
};

export const getAllMembersWithIncome = (members, students) => {
  return Array.prototype.concat(members, students).filter(x => hasIncome(x));
};

export const formatReleaseCategories = (releaseMapping = null) => {
  let response = [];
  if (releaseMapping) {
    response = releaseMapping.map((release, index) => {
      return {
        key: index + 1,
        text: release.Description,
        value: release.Id,
      };
    });
  }

  return response;
};



// WEBPACK FOOTER //
// ./src/pages/manageapplication/helpers/HouseholdExceptionHelpers.js